import { IAction } from '~/src/store';

import { ETicketPayment } from './index';

export type TSetQrCode = IAction<ETicketPayment.SET_QR_CODE, string>

const setQrCode = (code: string): TSetQrCode => ({
    type: ETicketPayment.SET_QR_CODE,
    payload: code,
});

export default setQrCode;
